import { FC, useEffect, useState } from 'react';
import { Button, Modal } from 'antd';
import { AiOutlineClose } from 'react-icons/ai';
import { useTranslation } from 'react-i18next';
import Loader from '../../../../../components/Loader';

interface IProps {
  visible: boolean;
  step: 'REFUND' | 'COMPLETE' | 'CANCEL';

  onCancel(): void;
}

const PaymentRefundPosProcessModal: FC<IProps> = ({
                                                    visible,
                                                    step,
                                                    onCancel,
                                                  }) => {
  const { t } = useTranslation();

  const [isPaymentFail, setIsPaymentFail] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setIsLoading(true);
  }, []);

  const onLocalCancel = () => {
    isPaymentFail && onCancel();
  };

  const buttonRender = () => {
    switch (step) {
      case 'COMPLETE':
      case 'CANCEL':
        return (
          <Button key="cancel" className="btn-basic pink" onClick={onCancel}>
            {t('common.button.confirm')}
          </Button>
        );
    }
  };

  const messageRender = () => {
    switch (step) {
      case 'REFUND':
        return (
          <>
            <p>환불 진행할 카드를 삽입해주세요</p>
          </>
        );
      case 'CANCEL':
        return (
          <>
            <p>환불 실패 했습니다.</p>
            <p>(유효하지 않은 거래)</p>
          </>
        );
      case 'COMPLETE':
        return (
          <>
            <p>환불 완료 되었습니다.</p>
          </>
        );
    }
  };

  return (
    <>
      {isLoading ? <Loader /> : null}
      <Modal
        title={t('student.student.button18')}
        visible={visible}
        onCancel={onLocalCancel}
        width={600}
        closeIcon={<AiOutlineClose onClick={onLocalCancel} />}
        footer={[
          <div className="comm-btn__area justify-content-center">
            {buttonRender()}
          </div>,
        ]}
      >
        <div className="text-center">
          {messageRender()}
        </div>
      </Modal>
    </>
  );
};

export default PaymentRefundPosProcessModal;
